(function(angular, window) {
    window.THF = window.THF || {};
    window.THF.Angular = window.THF.Angular || {};

    window.THF.Angular.LiveQuoteTool = angular.module('thfLiveQuoteTool', ['thfFilters', 'thfApi', 'ngAnimate', 'ngDialog', 'ui.mask', 'ngTouch']);

})(angular, window);
